<template>
    <div>
        <div class="hot_imgs">
            <div class="title" v-if="configData.title">
                {{configData.title}}
            </div>
            <div class="list-box">
                <draggable  class="dragArea list-group" v-model="configData.list" item-key="id">
                    <template v-for="(element, index) in configData.list">
                        <div class="item" :key="index + ''" >
                            <div class="move-icon">
                                <span class="iconfont icondrag"></span>
                            </div>
                            <div class="img-box">
                                <el-upload
                                        style="width: 70px;height: 70px;"
                                        class="single-image"
                                        list-type="single-image"
                                        :on-success="(value) => uploadSuccess(index, value)"
                                        :show-file-list="false"
                                        :action="app_url + '/store/uploader/upload'">
                                    <img :src="element.img" style="width: 70px;height: 70px;" alt=""  v-if="element.img">
                                    <div class="upload-box" style="width: 70px;height: 70px;" v-else>
                                        <el-icon class="iconfont el-icon-camera" size="36" />
                                    </div>
                                </el-upload>
                                <div class="delect-btn" @click.stop="bindDelete(element,index)" v-if="!configData.isCube">
                                    <span class="iconfont icondel_1"></span>
                                </div>
                            </div>
                            <div class="info">
                                <div class="info-item" v-for="(infos,key) in element.info" :key="key">
                                    <span>{{element.title}}</span>
                                    <div class="input-box" @click="getLink(index,key,element.info)">
                                        <el-input v-model="infos.value" :readonly="key==element.info.length-1?true:false" :placeholder="infos.tips" :maxlength="infos.max+100" v-if="configData.isCube" @on-blur="onBlur"></el-input>
                                        <el-input v-model="infos.value" :readonly="key==element.info.length-1?true:false" :placeholder="infos.tips" :maxlength="infos.max+100" v-else>
                                            <template #append v-if="key == element.info.length - 1">
                                                <el-icon class="el-icon-arrow-right"></el-icon>
                                            </template>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </draggable>
            </div>
            <div class="add-btn">
                <el-button class="new-btn" plain @click="addBox" v-if="configData.list.length < configData.maxList">添加板块</el-button>
            </div>
        </div>
        <linkaddress ref="linkaddress" @linkUrl="linkUrl"></linkaddress>
    </div>
</template>

<script>
    import fileImages from "@/components/fileImages/index.vue";
    import linkaddress from '@/components/linkaddress/index.vue';
    import draggable from 'vuedraggable'
    export default {
        name: "images",
        components: {
            fileImages,
            linkaddress,
            draggable
        },
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {
                modalPic: false,
                isChoice: 1,
                activeIndex: -1,

                indexLast: 0,
                lastObj: {}
            }
        },
        methods: {
            addBox () {
                if (this.configData.list.length == 0) {

                    this.lastObj.img = '';
                    if (this.configData.showTitle) {
                        this.lastObj.info[0].value = '';
                        this.lastObj.info[1].value = '';
                    } else {
                        this.lastObj.info[0].value = '';
                    }

                    this.configData.list.push(this.lastObj)
                } else {
                    let obj = JSON.parse(JSON.stringify(this.configData.list[this.configData.list.length - 1]))
                    obj.img = '';
                    if (this.configData.showTitle) {
                        obj.info[0].value = '';
                        obj.info[1].value = '';
                    } else {
                        obj.info[0].value = '';
                    }

                    this.configData.list.push(obj)
                }
            },
            // 点击商品图
            modalPicTap(tit, index) {
                this.modalPic = true;
                this.isChoice = tit === "dan" ? 1 : 0;
                this.activeIndex = index
            },
            uploadSuccess(key, res, file) {
                this.configData.list[key].img = res.data.fileInfo.external_url;
                this.$forceUpdate()
            },
            // 删除
            bindDelete (item, index) {
                if (this.configData.list.length == 1) {
                    return this.$message.error('最少一个')
                }
                this.configData.list.splice(index, 1)
            },
            linkUrl(e){
                this.configData.list[this.activeIndex].info[this.indexLast].value = e
            },
            getLink (index,key,item){
                this.indexLast = item.length - 1
                if(key != item.length - 1){
                    return
                }
                this.activeIndex = index
                this.$refs.linkaddress.modals = true
            },
            closeDialog: function () {
                this.modalPic = false;
            }
        }
    }
</script>

<style scoped>
    .hot_imgs .title {
        padding: 13px 0;
        color: #999;
        font-size: 12px;
        border-bottom: 1px solid rgba(0,0,0,0.05);
    }
    .hot_imgs .list-box .item {
        position: relative;
        display: flex;
        margin-top: 20px;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
    }
    .hot_imgs .list-box .item .move-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 80px;
        cursor: move;
    }
    .hot_imgs .list-box .item .img-box {
        position: relative;
        width: 70px;
        height: 70px;
    }
    .hot_imgs .list-box .item .img-box img {
        width: 100%;
        height: 100%;
    }
    .hot_imgs .list-box .item .info {
        flex: 1;
        margin-left: 22px;
    }
    .hot_imgs .list-box .item .info .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }
    .hot_imgs .list-box .item .info .info-item span{
        width: 40px;
        font-size: 13px;
    }
    .hot_imgs .list-box .item .info .info-item .input-box{
        flex: 1;
    }
    .upload-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: #ccc;
    }
    .hot_imgs .add-btn {
        margin-top: 10px;
    }
    .hot_imgs .list-box .item .delect-btn {
        position: absolute;
        right: -7px;
        top: -12px;
    }
    .new-btn{
        width: 100%;
        height: 40px;
        border-color: var(--el-color-primary);
        color: var(--el-color-primary);
    }
</style>
